
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/meteo/detail-radar/[locality]",
      function () {
        return require("private-next-pages/meteo/detail-radar/[locality].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/meteo/detail-radar/[locality]"])
      });
    }
  